import moment from "moment";
import { LocaleUtil, StringUtil } from "@eres/core";
import { LocaleValue } from "@eres/core/dist/LocaleValue";

interface BaseVaultItem {
	_id: string;
	name: string;
	createdAt: number;
	updatedAt: number;
	refNumber: string;
}

export interface FileItem extends BaseVaultItem {
	size: number;
}

export interface FolderItem extends BaseVaultItem {
	folders?: FolderItem[];
	files?: FileItem[];
}

export interface TokenAccess {
	_id: string;
	dlToken: string;
}

interface VaultError extends LocaleValue {
	code: string;
	desc?: string;
	src?: string;
}

export interface VaultResponse<T> {
	data: T,
	error?: VaultError;
}

export function readableFileSize( size: number ): string {
	if ( size == null ) return "";
	const units = [ "B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB" ];
	let i = 0;
	while ( size >= 1024 ) {
		size /= 1024;
		++i;
	}
	return size.toFixed( 2 ) + " " + units[ i ];
}

export function getItemDate( item: BaseVaultItem ): Date | undefined {
	let ts = item.updatedAt || item.createdAt;
	if ( !ts ) return undefined;
	return moment.unix( ts ).toDate();
}

export function exToMessage( e: any ): Promise<{ error: string, src?: string, content?: VaultResponse<any> }> {
	if ( e.type === "webservice_error" ) {
		if ( e.source && e.source.json ) {
			return e.source.json().then( ( msg: any ) => {
				let r: VaultResponse<any> = msg;
				let error: string | undefined = undefined;
				let apiError = r && r.error;
				let source: string | undefined = undefined;
				if ( apiError ) {
					source = apiError.src;
					error = LocaleUtil.getLocalValue( apiError );
					if ( StringUtil.isEmptyStringOrNull( error ) ) {
						error = apiError.desc;
					}
					if ( StringUtil.isEmptyStringOrNull( error ) ) {
						error = apiError.code;
					}
				}
				if ( StringUtil.isEmptyStringOrNull( error ) && msg && msg.message ) {
					error = msg.message;
				}
				if ( StringUtil.isEmptyStringOrNull( error ) ) {
					error = e.toString();
				}
				return Promise.resolve( { error: error, content: msg, src: source } );
			} ).catch( ( ex: any ) => {
				return Promise.resolve( { error: e.toString() } );
			} );
		}
	}
	return Promise.resolve( { error: e.toString() } );
}
